/**
 * Shipping Protection automatic add (GR task 0.11, theme side)
 *
 * Shipping Protection stays on by default, but it is only added once a real product is in the cart
 * (it used to be added on page load for every new visitor and bot). The add goes through
 * navigator.sendBeacon, which Shopify's cart tracking does not see, so it no longer fires
 * add_to_cart in GA4, Meta or Klaviyo. A deliberate tick or untick in the drawer still uses fetch.
 *
 * Default is per cart: pre-ticked and auto-added unless this cart carries the attribute
 * "Shipping Insurance" = "False" (set by an untick in the drawer or on the cart page). A new cart
 * starts pre-ticked again.
 */
(function () {
  if (window.__shippingProtectionLoaded) return;
  window.__shippingProtectionLoaded = true;

  var MAX_ADDS = 2;
  var checkbox = null;
  var variantId = 0;
  var busy = false;
  var adds = 0;
  var timer = null;

  function getCart() {
    return fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function (response) {
      return response.json();
    });
  }

  function hasProtection(cart) {
    return cart.items.some(function (item) {
      return item.variant_id === variantId;
    });
  }

  function optedOut(cart) {
    return !!cart.attributes && cart.attributes['Shipping Insurance'] === 'False';
  }

  // Not a fetch/XHR, so the storefront's add-to-cart tracking never sees it
  function addQuietly() {
    var sent = false;
    try {
      sent = navigator.sendBeacon('/cart/add.js', new URLSearchParams({id: String(variantId), quantity: '1'}));
    } catch (error) {
      sent = false;
    }
    if (sent) return Promise.resolve();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json'},
      body: 'quantity=1&id=' + variantId,
    });
  }

  // The beacon has no response, so poll until the cart shows the line
  function waitForLine(attempt) {
    return getCart().then(function (cart) {
      if (hasProtection(cart)) return true;
      if (attempt >= 14) return false;
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 350);
      }).then(function () {
        return waitForLine(attempt + 1);
      });
    });
  }

  function check() {
    if (busy || !checkbox || adds >= MAX_ADDS) return;
    busy = true;

    getCart()
      .then(function (cart) {
        if (hasProtection(cart) || optedOut(cart)) return;
        var hasProduct = cart.items.some(function (item) {
          return item.variant_id !== variantId;
        });
        if (!hasProduct) return;

        adds += 1;
        checkbox.checked = true;
        return addQuietly()
          .then(function () {
            return waitForLine(0);
          })
          .then(function (found) {
            if (!found) return;
            // The customer may have unticked it while the add was in flight
            if (!checkbox.checked) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json'},
                body: 'quantity=0&id=' + variantId,
              }).then(function () {
                document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
              });
            }
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(check, 200);
  }

  function init() {
    checkbox = document.getElementById('shpping_product');
    if (!checkbox) return;
    variantId = parseInt(checkbox.value, 10);
    if (!variantId) return;

    document.addEventListener('theme:cart:change', schedule);
    document.addEventListener('theme:product:added', schedule);
    document.addEventListener('theme:cart-drawer:open', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
